// extracted by mini-css-extract-plugin
export default {"wrapper":"ApprovalPage_wrapper__SHu9P","reapprove":"ApprovalPage_reapprove__ODyxG","preview":"ApprovalPage_preview__Fd94O"};